import { apiClient } from '../client'
import type { PagedResponse } from '../client'

export interface SyncStatus {
  syncType: string
  lastSyncedAt: string
  lastPublicationDate: string | null
  lastPageProcessed: number | null
  totalRecordsSynced: number | null
}

export interface RecpoRecord {
  id: string
  ruc: string
  recpoCode: string
  resourceDate: string | null
  condition: string | null
  situation: string | null
  lastSyncedAt: string
}

export interface FormalizedMinerRecord {
  id: string
  documentNumber: string
  minerName: string
  uniqueCode: string
  miningRightName: string
  department: string
  province: string
  district: string
  resolutionNumber: string
  resolutionDate: string | null
  associateCount: number
  region: string
  lastSyncedAt: string
}

export interface ReinfoRecord {
  id: string
  ruc: string
  minerName: string
  uniqueCode: string
  miningRightName: string
  department: string
  province: string
  district: string
  estado: string
  lastSyncedAt: string
}

const BASE_PATH = '/sync'

export const syncService = {
  async getStatus(): Promise<SyncStatus[]> {
    return apiClient.get<SyncStatus[]>(`${BASE_PATH}/status`)
  },

  async getRecpo(params?: { page?: number; pageSize?: number; search?: string }): Promise<PagedResponse<RecpoRecord>> {
    return apiClient.get<PagedResponse<RecpoRecord>>(`${BASE_PATH}/recpo`, params)
  },

  async getFormalizedMiners(params?: { page?: number; pageSize?: number; search?: string }): Promise<PagedResponse<FormalizedMinerRecord>> {
    return apiClient.get<PagedResponse<FormalizedMinerRecord>>(`${BASE_PATH}/formalized-miners`, params)
  },

  async getReinfo(params?: { page?: number; pageSize?: number; search?: string }): Promise<PagedResponse<ReinfoRecord>> {
    return apiClient.get<PagedResponse<ReinfoRecord>>(`${BASE_PATH}/reinfo`, params)
  },
}
